// 尤物视频 - 内容平台 Mock 数据
// 分类数据
export const categories = [
  { slug: 'shishang', name: '时尚', icon: 'ri-t-shirt-line', description: '潮流穿搭、时装周、设计师灵感', color: 'rose' },
  { slug: 'meizhuang', name: '美妆', icon: 'ri-brush-line', description: '化妆教程、护肤心得、美妆测评', color: 'pink' },
  { slug: 'shenghuo', name: '生活方式', icon: 'ri-heart-line', description: '居家美学、旅行日志、精致日常', color: 'amber' },
  { slug: 'sheying', name: '摄影', icon: 'ri-camera-line', description: '摄影技巧、视觉大片、后期教程', color: 'teal' },
  { slug: 'yishu', name: '艺术', icon: 'ri-palette-line', description: '当代艺术、设计灵感、创意短片', color: 'indigo' },
  { slug: 'yinyue', name: '音乐', icon: 'ri-music-line', description: 'MV精选、独立音乐、现场演出', color: 'violet' },
];

// 视频/文章数据
export const articles = [
  {
    id: 1,
    title: '2026秋冬时装周：极简主义回归，剪裁成为主角',
    slug: '2026-aw-fashion-week-minimalism',
    category: 'shishang',
    excerpt: '本季时装周各大品牌纷纷回归简约风格，精准的剪裁与优质面料成为设计核心。',
    content: `<p>2026年秋冬时装周在全球四大时尚之都陆续落幕，一个明显的趋势浮出水面——极简主义强势回归。从纽约到巴黎，设计师们不约而同地选择用精准的剪裁代替繁复的装饰。</p>
    <h2>剪裁至上</h2>
    <p>本季最引人注目的变化是对廓形的极致追求。Bottega Veneta用利落的肩线和大胆的比例重新定义了女性西装；The Row则延续了其一贯的克制美学，将质感与工艺推向极致。</p>
    <p>设计师Matthieu Blazy表示："在信息过载的时代，服装需要给人呼吸的空间。简约不是贫乏，而是精准。"</p>
    <h2>面料革新</h2>
    <p>除了剪裁，面料的创新也成为了本季亮点。Prada大量使用了可持续再生羊毛混纺面料，在保持奢华质感的同时兼顾环保理念。Loro Piana则推出了超轻羊绒系列，将传统工艺与现代科技完美融合。</p>
    <h2>色彩趋势</h2>
    <p>在色彩方面，本季流行的是沉稳的大地色系——从温暖的焦糖色到冷峻的灰褐色，再到永恒的黑色与白色，构成了一个克制而高级的调色盘。偶尔出现的酒红与深蓝则为整个系列增添了层次感。</p>
    <h2>配饰点睛</h2>
    <p>在极简的服装之外，配饰成为了表达个性的重要出口。超大号手袋、雕塑感耳环、及膝长靴等单品频繁出现在各大秀场，为简约造型增添了戏剧张力。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20fashion%20runway%20scene%20with%20minimalist%20designer%20clothing%20in%20warm%20earth%20tones%2C%20soft%20dramatic%20lighting%2C%20clean%20catwalk%20background%2C%20editorial%20fashion%20photography%20style%2C%20sophisticated%20aesthetic%2C%20neutral%20beige%20and%20cream%20backdrop&width=800&height=450&seq=article-01-cover&orientation=landscape',
    author: '林小雨',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20woman%20portrait%2C%20elegant%20style%2C%20warm%20lighting%2C%20clean%20cream%20background%2C%20soft%20natural%20makeup%2C%20editorial%20quality&width=100&height=100&seq=author-01-avatar&orientation=squarish',
    publishDate: '2026-08-10',
    readTime: '8分钟',
    views: 12800,
    likes: 2340,
    tags: ['时装周', '极简主义', '2026秋冬', '时尚趋势'],
    featured: true,
  },
  {
    id: 2,
    title: '清透底妆的秘密：化妆师私藏的5个技巧',
    slug: 'flawless-base-makeup-secrets',
    category: 'meizhuang',
    excerpt: '想要拥有韩剧女主角般的清透底妆？资深化妆师分享5个让底妆服帖持久的秘诀。',
    content: `<p>底妆是整个妆容的基础，一个好的底妆可以让后续的妆容更加出彩。今天，我们邀请了资深化妆师陈诗涵，为大家分享5个打造清透底妆的私藏技巧。</p>
    <h2>1. 妆前保湿是灵魂</h2>
    <p>很多人认为油皮不需要保湿，这其实是一个误区。无论什么肤质，充足的保湿都是底妆服帖的前提。建议在化妆前使用保湿精华和轻薄的面霜，等待5分钟完全吸收后再开始上妆。</p>
    <h2>2. 选对妆前乳</h2>
    <p>妆前乳不是可有可无的步骤。根据自己的肤质选择：干皮选择保湿型，油皮选择控油型，毛孔粗大选择填补型。取黄豆大小的量，用手指点涂在T区和两颊，轻轻拍开即可。</p>
    <h2>3. 少量多次上粉底</h2>
    <p>很多人习惯一次挤很多粉底液全脸上，这样容易造成厚重感。正确的方法是：先挤一泵在手背，用指腹蘸取后从面部中央向外推开，再用湿润的美妆蛋拍匀。需要遮瑕的部位可以叠加第二层。</p>
    <h2>4. 定妆喷雾替代散粉</h2>
    <p>如果想要保留肌肤的光泽感，可以尝试用定妆喷雾代替散粉。在完成底妆后，距离面部30厘米均匀喷洒定妆喷雾，既能让妆容更持久，又不会掩盖皮肤的自然光泽。</p>
    <h2>5. 巧用遮瑕</h2>
    <p>遮瑕不要大面积使用。黑眼圈用橘色调遮瑕，痘痘用比肤色深半个色号的遮瑕，法令纹用比肤色浅半个色号的遮瑕提亮。用细头刷精准点涂，比用手指或大面积涂抹效果好得多。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Beautiful%20minimalist%20makeup%20flat%20lay%20with%20foundation%20bottles%20and%20brushes%20on%20cream%20marble%20surface%2C%20soft%20natural%20lighting%2C%20elegant%20beauty%20product%20photography%2C%20warm%20neutral%20tones%2C%20clean%20aesthetic&width=800&height=450&seq=article-02-cover&orientation=landscape',
    author: '陈诗涵',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Asian%20female%20makeup%20artist%20portrait%2C%20elegant%20minimal%20style%2C%20warm%20studio%20lighting%2C%20cream%20background%2C%20sophisticated%20look&width=100&height=100&seq=author-02-avatar&orientation=squarish',
    publishDate: '2026-08-09',
    readTime: '6分钟',
    views: 9600,
    likes: 1850,
    tags: ['底妆', '化妆技巧', '美妆教程', '清透妆容'],
    featured: true,
  },
  {
    id: 3,
    title: '东京旅居日记：藏在巷弄里的独立咖啡馆',
    slug: 'tokyo-hidden-cafes-guide',
    category: 'shenghuo',
    excerpt: '远离喧闹的游客区，探访东京5家藏在巷弄深处的独立咖啡馆，感受慢节奏的日式生活美学。',
    content: `<p>东京是一座充满对比的城市。一面是涩谷十字路口的霓虹与人潮，另一面则是藏在安静巷弄里的独立咖啡馆——那里的时间仿佛被按下了慢放键。</p>
    <h2>About Life Coffee Brewers（代代木上原）</h2>
    <p>藏在住宅区的小巷里，这家只有8个座位的小店是真正的隐藏宝藏。店主山田先生每天亲自手冲每一杯咖啡，使用自己烘焙的单品豆。坐在吧台前，看着咖啡缓缓滴落，窗外的绿植在微风中摇曳——这就是东京最治愈的午后时光。</p>
    <h2>Onibus Coffee（奥泽）</h2>
    <p>由一栋老旧的二层木造民居改造而成，Onibus像是从绘本里走出来的咖啡馆。二楼的榻榻米座位区特别受欢迎，你可以脱掉鞋子，盘腿坐着喝咖啡。他们的拿铁使用的是与本地牧场合作的新鲜牛乳，奶泡绵密得像是云朵。</p>
    <h2>Café de l'Ambre（银座）</h2>
    <p>这家创立于1948年的老牌咖啡馆是东京咖啡文化活化石。店主关口一郎先生（已故）被称为"咖啡之神"，店里至今仍使用着他设计的咖啡器具。推荐尝试"琥珀女王"——一款用陈年咖啡豆制作的特调，冰凉的玻璃杯中咖啡如琥珀般晶莹。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Cozy%20Japanese%20independent%20coffee%20shop%20interior%20in%20Tokyo%20backstreet%2C%20warm%20wooden%20furniture%2C%20soft%20afternoon%20light%20through%20window%2C%20minimalist%20aesthetic%2C%20plants%20decor%2C%20serene%20atmosphere&width=800&height=450&seq=article-03-cover&orientation=landscape',
    author: '周以安',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20male%20travel%20writer%20portrait%2C%20casual%20stylish%20look%2C%20warm%20natural%20lighting%2C%20cream%20background%2C%20friendly%20expression&width=100&height=100&seq=author-03-avatar&orientation=squarish',
    publishDate: '2026-08-08',
    readTime: '10分钟',
    views: 15600,
    likes: 3120,
    tags: ['东京', '咖啡馆', '旅行', '日式美学'],
    featured: true,
  },
  {
    id: 4,
    title: '手机也能拍大片：5个构图技巧让你的照片提升质感',
    slug: 'mobile-photography-composition-tips',
    category: 'sheying',
    excerpt: '不需要昂贵设备，掌握这5个手机摄影构图技巧，普通人也能拍出质感大片。',
    content: `<p>摄影不在于设备，而在于眼睛。以下5个构图技巧，可以让你的手机照片立刻提升一个档次。</p>
    <h2>1. 三分法——最经典的构图法则</h2>
    <p>打开手机相机的网格线功能，将画面横向和纵向各分为三等分。将拍摄主体放在四个交叉点的任意一个上，比放在正中央更有视觉张力。例如拍摄人像时，将人物的眼睛放在上方交叉点。</p>
    <h2>2. 引导线——让画面更有深度</h2>
    <p>利用道路、栏杆、河流、建筑边缘等线条，引导观众的视线向画面深处延伸。引导线不需要是直线，S形曲线往往更有韵味。试着在拍摄街道时，让马路从画面一角延伸到远方。</p>
    <h2>3. 框架构图——创造层次感</h2>
    <p>利用门框、窗户、拱门、树枝等自然元素作为前景框架，把主体框在其中。这种手法可以增加画面的层次感和纵深感，让照片看起来像精心设计的画作。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Smartphone%20photography%20setup%20on%20minimalist%20wooden%20desk%2C%20phone%20displaying%20beautiful%20composition%20grid%2C%20warm%20golden%20hour%20lighting%2C%20clean%20cream%20background%2C%20elegant%20flat%20lay%20style&width=800&height=450&seq=article-04-cover&orientation=landscape',
    author: '苏景明',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Asian%20male%20photographer%20portrait%2C%20artistic%20style%2C%20warm%20studio%20lighting%2C%20cream%20background%2C%20creative%20look&width=100&height=100&seq=author-04-avatar&orientation=squarish',
    publishDate: '2026-08-07',
    readTime: '7分钟',
    views: 22100,
    likes: 4560,
    tags: ['手机摄影', '构图技巧', '摄影教程', '拍照'],
    featured: true,
  },
  {
    id: 5,
    title: '当代艺术新浪潮：数字媒介如何重塑艺术表达',
    slug: 'digital-media-reshaping-art',
    category: 'yishu',
    excerpt: '从AI生成到VR装置，数字技术正在以前所未有的方式拓展艺术的边界。',
    content: `<p>当AI可以生成以假乱真的画作，当VR可以让观众走进艺术家的内心世界，我们不得不重新思考：什么是艺术？</p>
    <h2>AI与艺术创作</h2>
    <p>2026年，AI生成艺术已经从争议走向主流。越来越多的艺术家将AI视为创作伙伴而非威胁。数字艺术家林锐表示："AI就像是无限延伸的画笔，它不会取代艺术家，而是让艺术家能够探索以前无法触及的领域。"</p>
    <h2>沉浸式体验的崛起</h2>
    <p>TeamLab的成功证明了观众对于沉浸式数字艺术体验的渴望。2026年，更多艺术家开始利用VR和AR技术，创造能够让观众"走进"作品中的体验。北京尤伦斯当代艺术中心最近举办的"数字幻境"展览，开展首周即吸引了超过3万名观众。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20digital%20art%20installation%20with%20flowing%20abstract%20light%20projections%20in%20dark%20gallery%20space%2C%20immersive%20experience%2C%20warm%20gold%20and%20rose%20light%20patterns%2C%20futuristic%20aesthetic&width=800&height=450&seq=article-05-cover&orientation=landscape',
    author: '林锐',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20digital%20artist%20portrait%2C%20creative%20stylish%20look%2C%20warm%20studio%20lighting%2C%20cream%20background%2C%20artistic%20expression&width=100&height=100&seq=author-05-avatar&orientation=squarish',
    publishDate: '2026-08-06',
    readTime: '9分钟',
    views: 8900,
    likes: 1670,
    tags: ['数字艺术', 'AI艺术', '当代艺术', '沉浸式体验'],
    featured: false,
  },
  {
    id: 6,
    title: '独立音乐人专访：卧室里诞生的金曲',
    slug: 'bedroom-producer-interview',
    category: 'yinyue',
    excerpt: '没有专业录音棚，一台笔记本电脑加一把吉他，这些独立音乐人如何在卧室里创作出爆款歌曲。',
    content: `<p>在流媒体时代，越来越多的优秀音乐作品诞生于卧室而非专业录音棚。我们采访了三位独立音乐人，听听他们的创作故事。</p>
    <h2>李晨阳：从程序员到独立音乐人</h2>
    <p>白天写代码，晚上写歌——李晨阳的2025年单曲《城市之光》在网易云音乐获得了超过5000万次播放。"其实卧室录音最大的挑战不是设备，而是隔音。我用衣柜和棉被搭了一个简易录音棚，效果还不错。"</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Cozy%20bedroom%20music%20studio%20with%20laptop%20guitar%20and%20warm%20fairy%20lights%2C%20creative%20atmosphere%2C%20soft%20ambient%20lighting%2C%20bohemian%20aesthetic%2C%20cream%20walls%2C%20plants%20decor&width=800&height=450&seq=article-06-cover&orientation=landscape',
    author: '王安琪',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20female%20music%20journalist%20portrait%2C%20casual%20chic%20style%2C%20warm%20lighting%2C%20cream%20background%2C%20friendly%20smile&width=100&height=100&seq=author-06-avatar&orientation=squarish',
    publishDate: '2026-08-05',
    readTime: '8分钟',
    views: 7200,
    likes: 1290,
    tags: ['独立音乐', '音乐人', '创作故事', '卧室制作'],
    featured: false,
  },
  {
    id: 7,
    title: '换季护肤指南：敏感肌如何平稳度过换季期',
    slug: 'sensitive-skin-seasonal-care',
    category: 'meizhuang',
    excerpt: '换季是敏感肌最头疼的时期，皮肤科医生和资深护肤达人联手为你支招。',
    content: `<p>每到换季，敏感肌的朋友就开始了"战痘"之旅。红肿、脱皮、刺痛……这些烦恼我们懂。今天带来一份完整的换季护肤指南。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20skincare%20products%20arranged%20on%20cream%20marble%20surface%20with%20fresh%20flowers%2C%20minimalist%20beauty%20photography%2C%20soft%20natural%20lighting%2C%20warm%20neutral%20tones%2C%20clean%20aesthetic&width=800&height=450&seq=article-07-cover&orientation=landscape',
    author: '陈诗涵',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Asian%20female%20makeup%20artist%20portrait%2C%20elegant%20minimal%20style%2C%20warm%20studio%20lighting%2C%20cream%20background%2C%20sophisticated%20look&width=100&height=100&seq=author-02-avatar&orientation=squarish',
    publishDate: '2026-08-04',
    readTime: '7分钟',
    views: 11300,
    likes: 2780,
    tags: ['护肤', '敏感肌', '换季', '皮肤管理'],
    featured: false,
  },
  {
    id: 8,
    title: '北欧家居美学：打造温暖治愈的居家空间',
    slug: 'scandinavian-home-decor-guide',
    category: 'shenghuo',
    excerpt: '北欧人为什么幸福感这么高？也许答案就藏在他们的居家设计哲学中。',
    content: `<p>北欧设计的核心是"hygge"——一种关于舒适、温暖和满足感的生活方式。以下是打造北欧风家居的5个关键元素。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Cozy%20Scandinavian%20living%20room%20interior%20with%20warm%20neutral%20textiles%2C%20wooden%20furniture%2C%20candles%2C%20minimalist%20design%2C%20soft%20natural%20light%20through%20large%20window%2C%20cream%20walls&width=800&height=450&seq=article-08-cover&orientation=landscape',
    author: '周以安',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20male%20travel%20writer%20portrait%2C%20casual%20stylish%20look%2C%20warm%20natural%20lighting%2C%20cream%20background%2C%20friendly%20expression&width=100&height=100&seq=author-03-avatar&orientation=squarish',
    publishDate: '2026-08-03',
    readTime: '6分钟',
    views: 9800,
    likes: 2030,
    tags: ['北欧风', '家居设计', '生活方式', '室内设计'],
    featured: false,
  },
  {
    id: 9,
    title: '2026夏季流行色：如何将蜜桃粉穿出高级感',
    slug: 'summer-2026-peach-pink-styling',
    category: 'shishang',
    excerpt: '蜜桃粉是2026夏季的绝对主角，学会这些搭配法则，轻松驾驭这个甜美色调。',
    content: `<p>蜜桃粉（Peach Pink）被评为2026年夏季最具影响力的色彩，从时装周到街头，这个温柔又充满活力的色调无处不在。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20fashion%20model%20wearing%20peach%20pink%20outfit%2C%20minimalist%20styling%2C%20soft%20studio%20lighting%2C%20cream%20backdrop%2C%20editorial%20fashion%20photography%2C%20warm%20summer%20aesthetic&width=800&height=450&seq=article-09-cover&orientation=landscape',
    author: '林小雨',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20woman%20portrait%2C%20elegant%20style%2C%20warm%20lighting%2C%20clean%20cream%20background%2C%20soft%20natural%20makeup%2C%20editorial%20quality&width=100&height=100&seq=author-01-avatar&orientation=squarish',
    publishDate: '2026-08-02',
    readTime: '5分钟',
    views: 18500,
    likes: 3890,
    tags: ['夏季流行', '蜜桃粉', '色彩搭配', '穿搭'],
    featured: false,
  },
  {
    id: 10,
    title: '街头摄影大师课：捕捉城市中的决定性瞬间',
    slug: 'street-photography-masterclass',
    category: 'sheying',
    excerpt: '跟随街头摄影大师Henri的视角，学习如何在喧嚣的城市中发现并捕捉那些转瞬即逝的诗意瞬间。',
    content: `<p>街头摄影的魅力在于它的不可预测性。你永远不知道下一秒会发生什么，而这正是它最迷人的地方。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Artistic%20black%20and%20white%20street%20photography%20scene%2C%20urban%20cityscape%20with%20pedestrians%2C%20dramatic%20light%20and%20shadow%2C%20decisive%20moment%20capture%2C%20warm%20tone%20monochrome&width=800&height=450&seq=article-10-cover&orientation=landscape',
    author: '苏景明',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Asian%20male%20photographer%20portrait%2C%20artistic%20style%2C%20warm%20studio%20lighting%2C%20cream%20background%2C%20creative%20look&width=100&height=100&seq=author-04-avatar&orientation=squarish',
    publishDate: '2026-08-01',
    readTime: '11分钟',
    views: 13400,
    likes: 2670,
    tags: ['街头摄影', '摄影技巧', '城市', '决定性瞬间'],
    featured: false,
  },
  {
    id: 11,
    title: '独立短片《归途》：用影像讲述回家的故事',
    slug: 'short-film-homecoming-review',
    category: 'yishu',
    excerpt: '年轻导演张若昀的首部短片作品，用温暖的镜头语言讲述了一个关于归属感的故事。',
    content: `<p>在短视频泛滥的时代，一部15分钟的独立短片《归途》却让人静下心来，重新思考"家"的意义。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Cinematic%20scene%20of%20golden%20hour%20countryside%20road%20leading%20home%2C%20warm%20nostalgic%20atmosphere%2C%20film%20grain%20texture%2C%20artistic%20cinematography%2C%20soft%20lens%20flare&width=800&height=450&seq=article-11-cover&orientation=landscape',
    author: '林锐',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20digital%20artist%20portrait%2C%20creative%20stylish%20look%2C%20warm%20studio%20lighting%2C%20cream%20background%2C%20artistic%20expression&width=100&height=100&seq=author-05-avatar&orientation=squarish',
    publishDate: '2026-07-30',
    readTime: '6分钟',
    views: 5600,
    likes: 1120,
    tags: ['独立短片', '电影', '归途', '导演'],
    featured: false,
  },
  {
    id: 12,
    title: '复古黑胶回潮：为什么年轻人开始听唱片',
    slug: 'vinyl-record-comeback-trend',
    category: 'yinyue',
    excerpt: '在流媒体时代，黑胶唱片的销量却连续多年增长。这种复古的听歌方式为何吸引年轻一代？',
    content: `<p>打开唱片机，放上黑胶，等待唱针落下的那一刻……这个过程本身就充满了仪式感。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Vintage%20vinyl%20record%20player%20on%20wooden%20shelf%20with%20warm%20ambient%20lighting%2C%20collection%20of%20records%2C%20nostalgic%20retro%20aesthetic%2C%20cozy%20room%20atmosphere%2C%20cream%20walls%20background&width=800&height=450&seq=article-12-cover&orientation=landscape',
    author: '王安琪',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20female%20music%20journalist%20portrait%2C%20casual%20chic%20style%2C%20warm%20lighting%2C%20cream%20background%2C%20friendly%20smile&width=100&height=100&seq=author-06-avatar&orientation=squarish',
    publishDate: '2026-07-28',
    readTime: '7分钟',
    views: 6400,
    likes: 980,
    tags: ['黑胶', '复古', '音乐文化', '唱片'],
    featured: false,
  },
];

// 按分类获取文章
export function getArticlesByCategory(slug: string) {
  return articles.filter(a => a.category === slug);
}

// 获取推荐文章
export function getFeaturedArticles() {
  return articles.filter(a => a.featured);
}

// 获取最新文章
export function getLatestArticles(limit = 6) {
  return [...articles].sort((a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime()).slice(0, limit);
}

// 关于我们 - 品牌信息
export const aboutInfo = {
  brandName: '尤物视频',
  brandIntro: '尤物视频创立于2023年，是一个专注于高颜值精选视频内容的数字媒体平台。我们相信，优质的视觉内容能够丰富人们的精神世界，提升生活品质。',
  mission: '为追求品质生活的你，甄选全球最具审美价值的视频内容。',
  stats: [
    { label: '精选视频', value: '50,000+' },
    { label: '活跃用户', value: '200万+' },
    { label: '合作创作者', value: '3,000+' },
    { label: '日均更新', value: '100+' },
  ],
  team: [
    { name: '沈以诚', role: '创始人 & CEO', bio: '前时尚媒体集团内容总监，15年内容行业经验。' },
    { name: '林晓薇', role: '内容总监', bio: '资深时尚编辑，曾任Vogue中国区数字内容负责人。' },
    { name: '王子豪', role: '技术负责人', bio: '前字节跳动高级工程师，专注视频技术领域。' },
    { name: '陈艺文', role: '创意总监', bio: '独立导演，作品曾入围戛纳电影节短片单元。' },
  ],
  milestones: [
    { year: '2023', event: '尤物视频正式上线，聚焦时尚美妆领域' },
    { year: '2024', event: '用户突破100万，内容覆盖扩展至六大品类' },
    { year: '2025', event: '获得A轮融资，合作创作者超过2000人' },
    { year: '2026', event: '月活用户突破500万，推出创作者扶持计划' },
  ],
  testimonials: [
    { name: '李小姐', role: '时尚博主', content: '尤物视频是我每天必刷的平台，内容质量真的很高，每次都能找到新的穿搭灵感。', avatar: 'https://readdy.ai/api/search-image?query=Fashionable%20Asian%20woman%20portrait%2C%20elegant%20style%2C%20warm%20lighting%2C%20cream%20background%2C%20confident%20smile&width=100&height=100&seq=testimonial-01&orientation=squarish' },
    { name: '张先生', role: '摄影师', content: '作为一个摄影爱好者，尤物视频上的视觉内容给了我很多创作灵感，强烈推荐！', avatar: 'https://readdy.ai/api/search-image?query=Professional%20Asian%20male%20portrait%2C%20artistic%20style%2C%20warm%20lighting%2C%20cream%20background%2C%20friendly%20expression&width=100&height=100&seq=testimonial-02&orientation=squarish' },
    { name: '王女士', role: '美妆达人', content: '尤物视频的美妆内容非常专业，化妆师的技巧分享让我学到了很多实用的方法。', avatar: 'https://readdy.ai/api/search-image?query=Beautiful%20Asian%20woman%20portrait%2C%20natural%20makeup%2C%20warm%20lighting%2C%20cream%20background%2C%20friendly%20smile&width=100&height=100&seq=testimonial-03&orientation=squarish' },
  ],
  contact: {
    email: 'hello@youwuvideo.com',
    phone: '400-888-9999',
    address: '上海市静安区南京西路1788号',
    wechat: 'youwuvideo',
    weibo: '@尤物视频',
  },
};